export interface BaseEnum {
  label?: string;
  value?: string;
  numberValue?: number;
  group?: any[];
  colorIndicator?: string;
}

export const getEnumNumber = (
  enumValue: string,
  enumValues: Array<BaseEnum>,
): number | undefined => {
  return enumValues.find(item => item.value === enumValue)?.numberValue;
};

export const getEnumLabel = (
  enumValue: string,
  enumValues: Array<BaseEnum>,
): string | undefined => {
  return enumValues.find(item => item.value === enumValue)?.label;
};

export const getEnum = (
  enumNumberValue: number,
  enumValues: Array<BaseEnum>,
): BaseEnum | undefined => {
  return enumValues.find(item => item.numberValue === enumNumberValue);
};
